export { DEFAULT_POLL_INTERVAL_MS as DEFAULT_EVENT_POLL_INTERVAL_MS } from '../../hooks';

export const RUNNING_EVENT_POLL_INTERVAL_MS = 3_000;
